import { useBack } from "./back";
import { t } from "./texts";

/** A full-width question with two big buttons (no native confirm(): too small for sweaty hands). */
export function ConfirmDialog(props: { text: string; confirm: string; cancel?: string; danger?: boolean; onConfirm(): void; onCancel(): void }) {
  useBack(props.onCancel);
  return (
    <div className="overlay" onClick={props.onCancel}>
      <div className="dialog" role="alertdialog" onClick={(e) => e.stopPropagation()}>
        <p>{props.text}</p>
        <div className="row">
          <button className="secondary" onClick={props.onCancel}>{props.cancel ?? t.cancel}</button>
          <button className={props.danger ? "danger" : "primary"} onClick={props.onConfirm}>{props.confirm}</button>
        </div>
      </div>
    </div>
  );
}
